// extracted by mini-css-extract-plugin
module.exports = {"container":"lohono-corporate-module__container___JC0pA"};